import styled from 'styled-components';

import { BaseModal } from '../../../../../components/Toolkit/Modal/BaseModal';

import { media } from '../../../../../helpers/breakpoints';

const SBaseModal = styled(BaseModal)`
  width: 320px;

  ${media.medium} {
    width: 680px;
    padding: ${({ theme }) => theme.spacing.L40};
  }
`;

const Header = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.S12};
  display: flex;
  align-items: center;
`;

const IconContainer = styled.div`
  height: 40px;
  width: 40px;
  margin-right: ${({ theme }) => theme.spacing.M16};
`;

const Title = styled.p`
  ${({ theme }) => theme.fontSize.L18};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
`;

const SubText = styled.p`
  ${({ theme }) => theme.fontSize.M16};
`;

const SimilarAdsContent = styled.div`
  margin-top: ${({ theme }) => theme.spacing.M16};
  padding-top: ${({ theme }) => theme.spacing.M16};
  border-top: 1px solid ${({ theme }) => theme.colors.GREY_LIGHT};
`;

const SimilarAdsBlurb = styled.p`
  ${({ theme }) => theme.fontSize.M16};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  margin-bottom: ${({ theme }) => theme.spacing.S8};
`;

const SimilarAdsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: ${({ theme }) => theme.spacing.S8};

  ${media.medium} {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export {
  SBaseModal,
  Header,
  IconContainer,
  Title,
  SubText,
  SimilarAdsContent,
  SimilarAdsBlurb,
  SimilarAdsGrid,
};
